import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

const defaults = { size: 20, color: "currentColor" };

export const IconAssignmentDue: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="5" y="3" width="14" height="18" rx="2" stroke={color} strokeWidth="1.8" />
    <path d="M9 7h6M9 11h6M9 15h4" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconWarningTriangle: React.FC<IconProps> = ({
  size = defaults.size,
  color = defaults.color,
  className
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 2L2 20h20L12 2z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 9v4" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="12" cy="16.5" r="0.8" fill={color} />
  </svg>
);

export const IconChartBar: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="4" y="12" width="4" height="8" rx="1" fill={color} opacity="0.6" />
    <rect x="10" y="6" width="4" height="14" rx="1" fill={color} opacity="0.8" />
    <rect x="16" y="9" width="4" height="11" rx="1" fill={color} />
  </svg>
);

export const IconTrophy: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M8 21h8M12 17v4M7 4h10v5a5 5 0 01-10 0V4z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7H4a1 1 0 00-1 1v1a4 4 0 004 4M17 7h3a1 1 0 011 1v1a4 4 0 01-4 4"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSpeaker: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M11 5L6 9H2v6h4l5 4V5z"
      fill={color}
      opacity="0.3"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.54 8.46a5 5 0 010 7.08M19.07 4.93a10 10 0 010 14.14"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const IconBookOpen: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M2 4a1 1 0 011-1h6a3 3 0 013 3v14a2 2 0 00-2-2H3a1 1 0 01-1-1V4z" stroke={color} strokeWidth="1.8" />
    <path d="M22 4a1 1 0 00-1-1h-6a3 3 0 00-3 3v14a2 2 0 012-2h7a1 1 0 001-1V4z" stroke={color} strokeWidth="1.8" />
  </svg>
);

export const IconTap: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M8.5 4.5a5.5 5.5 0 017.78 0M6.5 2.5a8.5 8.5 0 0111 0"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      opacity="0.45"
    />
    <path
      d="M12 8.5v5.2M12 13.7l-2.2 1.1a2.2 2.2 0 01-3-.9l-.2-.4a1.6 1.6 0 011.4-2.3l1.5.1V9.2a1.7 1.7 0 113.4 0v1.1l1.1-.1a1.8 1.8 0 011.9 1.7v.3l-.4 4.2a2.4 2.4 0 01-2.4 2.2H11.2a3.2 3.2 0 01-2.5-1.2l-1.4-1.8"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconFlame: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 2c.5 3.5-1.5 6-1.5 6C12 10 14 11 14 14c0 2.21-1.79 4-4 4-.5 0-1-.1-1.45-.28C10.56 18.87 12.58 20 15 20c3.31 0 6-2.69 6-6 0-5-4-8-6-12-1 2-3 3.5-3 3.5"
      fill={color}
      opacity="0.2"
    />
    <path
      d="M12 2c.5 3.5-1.5 6-1.5 6C12 10 14 11 14 14c0 2.21-1.79 4-4 4-.5 0-1-.1-1.45-.28C10.56 18.87 12.58 20 15 20c3.31 0 6-2.69 6-6 0-5-4-8-6-12-1 2-3 3.5-3 3.5"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBookPlaceholder: React.FC<IconProps> = ({
  size = defaults.size,
  color = defaults.color,
  className
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4 19V6a2 2 0 012-2h12a2 2 0 012 2v13" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M4 19a2 2 0 002 2h12a2 2 0 002-2" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M9 8h6M9 12h6" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconChevronDown: React.FC<IconProps> = ({ size = 16, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <polyline points="6 9 12 15 18 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconCheck: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <polyline points="20 6 9 17 4 12" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconCheckCircle: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.8" />
    <polyline points="8 12 11 15 16 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconClock: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.8" />
    <path d="M12 7v5l3.5 2" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconBookStack: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="4" y="15" width="16" height="3" rx="1" stroke={color} strokeWidth="1.8" />
    <rect x="5" y="11" width="14" height="3" rx="1" stroke={color} strokeWidth="1.8" />
    <rect x="3" y="7" width="18" height="3" rx="1" stroke={color} strokeWidth="1.8" />
    <path d="M8 7V5a1 1 0 011-1h6a1 1 0 011 1v2" stroke={color} strokeWidth="1.8" />
  </svg>
);

export const IconWave: React.FC<IconProps> = ({ size = defaults.size, color = defaults.color, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M7.5 12.5c-.5-1-1.5-1.5-2.5-1s-1.5 1.5-1 2.5l3 6c1.5 3 5 4 8 2.5l1-.5c2-1 3-3 2.5-5.5L17 9c-.2-1-1.2-1.6-2.2-1.4-.9.2-1.5 1-1.4 1.9l.6 3"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 12.5l-1-5c-.2-1-1.2-1.6-2.2-1.4-.9.2-1.5 1.1-1.3 2l1.5 7"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M9.5 15l-1.5-7.5c-.2-1-1.2-1.7-2.2-1.5-1 .2-1.6 1.2-1.4 2.2L6 14"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
